class segment {
    constructor(
        segmId,
        segment,
        days,
        numSequence
    
    
    ){
        this.segmId =segmId
        this.segment=segment
        this.days=days
        this.numSequence=numSequence
      

    
    }
    static fromJson({
        segmId,
        segmento,
        dias,
        numSecuencia
        
    }){
        return new segment(
            segmId,
            segmento,
            dias,
            numSecuencia
            
        )
    }
    }
    export default segment
    